export default __webpack_public_path__ + "static/media/newlocation.6bdb8a48.svg";